import type { ReactElement } from 'react';
import React, { memo, useEffect, useRef } from 'react';
import clsx from 'clsx';
import type { BuilderData } from './category-score-builder';
import { CategoryScoreBuilder } from './category-score-builder';
import './category-score-chart.scss';

type Props = { className?: string; theme?: string } & BuilderData;

const CategoryScoreChart = memo(({ className, theme, ...chartData }: Props): ReactElement => {
  const containerRef = useRef<HTMLDivElement>();

  // Plot chart after JSX rendered
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const builder = CategoryScoreBuilder.create({
      data: { ...chartData },
      options: { container }
    });

    builder.plot();
  }, [chartData]);

  return <div className={clsx('category-score-chart', className, theme)} ref={containerRef} />;
});

export default CategoryScoreChart;
